import { CnTab, CnTabItem } from '@/components/cn-tab';

export default [CnTab, CnTabItem];
